import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { RestService } from '../rest.service';
import { PasswordUtils } from '../utils/password.utils';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css']
})
export class ForgotpasswordComponent implements OnInit {

  constructor(private route: ActivatedRoute, private restService: RestService, private formBuilder: FormBuilder) { }

  tokenValue: any = "";
  tokenMode: boolean;

  isSuccess: boolean = false;
  isFailure: boolean = false;
  successMessage: any = "";
  failureMessage: any = "";

  email = "";
  newPassword = "";
  confirmPassword = "";

  userId: number;

  emailError: boolean;
  newPasswordError: boolean;
  confirmPasswordError: boolean;

  isLoading: boolean;

  newPasswordPatternError: boolean;
  confirmMisMatchError: boolean;

  forgotPasswordForm: any;

  ngOnInit() {
    this.email = "";
    this.newPassword = "";
    this.confirmPassword = "";
    this.tokenValue = this.route.snapshot.paramMap.get("token");

    this.newPasswordError = false;
    this.confirmPasswordError = false;

    if (this.tokenValue) {
      this.forgotPasswordForm = this.formBuilder.group({
        newPassword: ["", [Validators.required]],
        confirmPassword: ["", [Validators.required]]
      });
      this.newPasswordError = false;
      this.confirmPasswordError = false;
      this.newPasswordPatternError = false;
      this.confirmPasswordError = false;
      this.isLoading = true;

      this.restService
        .verifyEmailAddress(this.tokenValue, true)
        .pipe(
          catchError((e) => {
            this.isLoading = false;
            console.log("err --->", e);
            this.isFailure = true;
            this.failureMessage = e.error.StatusInfo;
            return e;
          })
        )
        .subscribe(
          (response: any) => {
            console.log(response);
            this.isLoading = false;
            this.userId = response.userId;
            this.newPasswordError = false;
            this.confirmPasswordError = false;
            this.newPasswordPatternError = false;
            this.confirmPasswordError = false;
          }
        );
      } else {
        this.forgotPasswordForm = this.formBuilder.group({
          email: ["", [Validators.required, Validators.email]]
        });
      }
  }

  onChangeEmail() {
    this.emailError = this.forgotPasswordForm.controls.email.status === "INVALID";
  }

  onChangeNewPassword() {
    this.newPasswordError = !this.newPassword || this.newPassword.length == 0;
    this.newPasswordPatternError = !PasswordUtils.checkPasswordRules(this.newPassword);
  }

  onChangeConfirmPassword() {
    this.confirmPasswordError = !this.confirmPassword || this.confirmPassword.length == 0;
    this.confirmMisMatchError = this.confirmPassword !== this.newPassword;
  }

  confirmFailureMessage() {
    this.isFailure = false;
    this.isSuccess = false;
  }

  confirmSuccessMessage() {
    this.isFailure = false;
    this.isSuccess = false;
  }

  submit() {

    if (this.tokenValue) {
      this.newPasswordError = !this.newPassword || this.newPassword.length == 0;
      this.newPasswordPatternError = !PasswordUtils.checkPasswordRules(this.newPassword);
      this.confirmPasswordError = !this.confirmPassword || this.confirmPassword.length == 0;
      this.confirmMisMatchError = this.confirmPassword !== this.newPassword;

      if (this.newPasswordPatternError || this.newPasswordError || this.confirmPasswordError || this.confirmMisMatchError ) {
        return;
      }

      this.restService
        .resetPassword(this.userId, PasswordUtils.encryptPassword(this.newPassword))
        .pipe(
          catchError((e) => {
            console.log(e)
            this.isLoading = false;
            this.isFailure = true;
            this.failureMessage = (e && (e.message || e.StatusInfo))  || "Failed to update password. Please try again"
            return e;
          })
        )
        .subscribe( (res: any) => {
          this.isLoading = false;
          
          if (res && res.status === "Success") {
            this.isSuccess = true;
            this.successMessage = res.message;
          } else {
            this.isFailure = true;
            this.failureMessage = res.message || res.StatusInfo || "Failed to update password. Please try again"
          }
        });

    } else {
      if (this.emailError) {
        return;
      }
      this.isLoading = true;

      this.restService.forgotPassword(this.email)
        .pipe(
          catchError((e) => {
            console.log("err --->", e);
            this.isLoading = false;
            this.isFailure = true;
            this.failureMessage = e.error.StatusInfo;
            return e;
          })
        )
        .subscribe(
          (res: any) => {
            this.isLoading = false;

            if (res && res.status === "Success") {
              this.isSuccess = true;
              this.successMessage = res.message || res.StatusInfo;
            } else {
              this.isFailure = true;
              this.failureMessage = res.message || res.StatusInfo;
            }
          }
        );

    }
  }

}
